import React, { Dispatch, SetStateAction } from "react";
import { Button, DatePicker, Form, FormInstance, Modal, Select } from "antd";
import styled from "@emotion/styled";
import { PlatformData } from "../../../distribution_partner/hooks/useDistributionData";
import { distributionPlatformFilterOptions } from "../../../utils";

type ExportModalProps = {
	isExportModalOpen: boolean;
	exportCSV: () => void;
	setIsExportModalOpen: (value: boolean) => void;
	form: FormInstance;
	distributionPlatformData: PlatformData[];
	exportFormat: string;
	setExportFormat: Dispatch<SetStateAction<string>>;
};

const ExportModal = styled(Modal)`
	& .ant-modal-body {
		margin-top: 16px;
		min-height: 220px;
	}
	& .ant-modal-footer {
		display: flex;
		justify-content: center;
	}
`;

const CommonExportModal: React.FC<ExportModalProps> = ({
	isExportModalOpen,
	setIsExportModalOpen,
	form,
	exportCSV,
	distributionPlatformData,
	exportFormat,
	setExportFormat,
}) => {
	const exportOptions = [
		{
			label: "All Fields  ",
			value: "videos",
			key: "videos",
		},
		
		{
			label: "All Fields with Distribution",
			value: "videos-distribution",
			key: "videos-distribution",
		},
		{
			label: "Amagi",
			value: "platforms/amagi",
			key: "platforms/amagi",
		},
		{
			label: "Pluto Avails",
			value: "pluto-avails",
			key: "pluto-avails",
		},
		{
			label: "Pluto",
			value: "platforms/pluto",
			key: "platforms/pluto",
		},
		{
			label: "Tubi",
			value: "platforms/tubi",
			key: "platforms/tubi",
		},
		{
			label: "Wurl",
			value: "platforms/wurl",
			key: "platforms/wurl",
		},
		{
			label: "Zype",
			value: "platforms/zype",
			key: "platforms/zype",
		},
	];
	const partnerNameOptions = [
		{
			label: "Nosey",
			value: "Nosey",
		},
		{
			label: "Confess by Nosey",
			value: "Confess by Nosey",
		},
		{
			label: "Judge Nosey",
			value: "Judge Nosey",
		},
		{
			label: "Nosey Escandalos",
			value: "Nosey Escandalos",
		},
	];

	const cancelHandler = () => {
		form.resetFields(["format"]);
		setIsExportModalOpen(false);
	};

	return (
		<ExportModal
			title="Export CSV"
			open={isExportModalOpen}
			onCancel={cancelHandler}
			footer={
				<Button type="primary" onClick={exportCSV}>
					Export CSV
				</Button>
			}
		>
			<Form requiredMark={false} form={form} initialValues={{ format: exportFormat }}>
				<Form.Item label="Format" name="format">
					<Select
						onChange={(value: string) => setExportFormat(value)}
						placeholder="Select Export Format"
						options={exportOptions}
					/>
				</Form.Item>
				{exportFormat === "pluto-avails" &&(
					<>
					<Form.Item label="Partner Name" name="partner_name">
						<Select placeholder="Select Partner Name" options={partnerNameOptions} allowClear />
					</Form.Item>
				
					<Form.Item
						label="Avail Start Date"
						name="avail_start_date"
						dependencies={["avail_end_date"]}
						rules={[
							{ required: true, message: "Please select avail start date" },
							({ getFieldValue }) => ({
								validator(_, value) {
									const availEndDate = getFieldValue("avail_end_date");
									if (!value || !availEndDate || !value.isAfter(availEndDate)) {
										return Promise.resolve();
									}
									return Promise.reject(
										new Error("Avail start date cannot be after avail end date")
									);
								},
							}),
						]}
					>
						<DatePicker
							style={{ width: "100%" }}
							placeholder="Select start date"
							format={["MM/DD/YYYY"]}
						/>
					</Form.Item>
		
		
					<Form.Item
						label="Avail End Date"
						name="avail_end_date"
						dependencies={["avail_start_date"]}
						rules={[
							{ required: true, message: "Please select avail end date" },
							({ getFieldValue }) => ({
								validator(_, value) {
									const availStartDate = getFieldValue("avail_start_date");
									if (!value || !availStartDate || !value.isBefore(availStartDate)) {
										return Promise.resolve();
									}
									return Promise.reject(
										new Error("Avail end date cannot be before avail start date")
									);
								},
							}),
						]}
					>
						<DatePicker
							style={{ width: "100%" }}
							placeholder="Select end date"
							format={["MM/DD/YYYY"]}
						/>
					</Form.Item>
					</>
				)}
				{(exportFormat === "platforms/amagi" || exportFormat === "platforms/pluto") && (
					<Form.Item label="Platforms" name="secondary_platforms">
						<Select
							placeholder="Distribution Platforms"
							filterOption={distributionPlatformFilterOptions}
							mode="multiple"
							allowClear
						>
							{distributionPlatformData.map((platformData: PlatformData) => {
								return (
									<Select.Option value={platformData.name} key={platformData.id}>
										{platformData.name}
									</Select.Option>
								);
							})}
						</Select>
					</Form.Item>
				)}
			</Form>
		</ExportModal>
	);
};

export default CommonExportModal;
